// extracted by mini-css-extract-plugin
export default {"field":"CheckBoxFormField_field__kAmuX"};